import * as angular from 'angular';
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";

export class BringozDateAndTimeRangePickerComponent implements IController {
  date: any;
  from: any;
  to: any;
  isRaised: any;
  ticks: any;
  minDate: any;
  maxDate: any;
  onChange: Function;

  constructor(private $mdPanel) {
  }

  $onInit() {
    if (!this.ticks) {
      this.ticks = 300000;
    }
  }

  onOpen($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.CENTER,
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.date-and-time-picker')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          date: this.date,
          from: this.from,
          to: this.to,
          ticks: _.toNumber(this.ticks),
          minDate: this.minDate,
          maxDate: this.maxDate
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: DateAndTimePanelComponent,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      templateUrl: 'app/modules/commons/components/bringoz-date-and-time-range-picker/template/panel-template.html',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: function (panel, reason) {
        panel.destroy();
      }
    };
    this.$mdPanel.open(config);
  }

  onClosePanel(config) {
    this.onChange({from: config.from, to: config.to});
  }


}

export class DateAndTimePanelComponent implements IController {
  dataRef: any;
  config: any;

  constructor(private mdPanelRef, private moment, private $timeout: ITimeoutService) {
  }

  $onInit() {
    this.dataRef = this.mdPanelRef.config.locals.data;
    this.config = {
      date: this.moment(this.dataRef.date).toDate(),
      from: this.moment(this.dataRef.from).valueOf(),
      to: this.moment(this.dataRef.to).valueOf(),
      ticks: this.dataRef.ticks,
      minDate: this.dataRef.minDate ? this.moment(this.dataRef.minDate).toDate() : undefined,
      maxDate: this.dataRef.maxDate ? this.moment(this.dataRef.maxDate).toDate() : undefined,
      min: this.moment(this.dataRef.date).startOf('day').valueOf(),
      max: this.moment(this.dataRef.date).endOf('day').valueOf(),
    };
  }

  onChangeDate(date) {
    const yearRef = this.moment(date).get('year');
    const monthRef = this.moment(date).get('month');
    const dateRef = this.moment(date).get('date');

    const fromRef = this.config.from;
    const toRef = this.config.to;

    this.config.date = date;

    this.config.min = this.moment(date).startOf('day').valueOf();
    this.config.max = this.moment(date).endOf('day').valueOf();

    this.$timeout(0).then(() => {
      this.config.from = this.moment(fromRef).set({'year': yearRef, 'month': monthRef, 'date': dateRef}).valueOf();
      this.config.to = this.moment(toRef).set({'year': yearRef, 'month': monthRef, 'date': dateRef}).valueOf();
    })
  }

  onRangeChange(from, to) {
    // Just for safety
    const isSameDay = this.sameDay(new Date(from), new Date(to));

    if (isSameDay) {
      this.config.from = this.moment(from).valueOf();
      this.config.to = this.moment(to).valueOf();
    }
  }

  submit() {
    this.mdPanelRef.close().then((mdPanelRef) => {
      mdPanelRef.config.locals.onClose(this.config);
    })
  }

  cancel() {
    this.mdPanelRef.close();
  }

  private sameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
  }
}


angular
  .module('bringoz.admin.commons')
  .component('bringozDateAndTimeRangePicker', {
    bindings: {
      date: '<',
      from: '<',
      to: '<',
      isRaised: '@?',
      ticks: '@?',
      minDate: '<?',
      maxDate: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-date-and-time-range-picker/bringoz-date-and-time-range-picker.html',
    controller: BringozDateAndTimeRangePickerComponent
  });
